module.exports = __webpack_public_path__ + "img/logo-light.5b8d1faf.png";